import apiClient from "./apiClient";
import {
  KiedyNaboryCustomer,
  MonthlySettlement,
  CreateOperationDto,
  SettlementOperation,
} from "../types/kiedynaborySettlements";

/**
 * Get list of KiedyNabory customers (tenants with kiedynabory brand)
 */
export const getKiedyNaboryCustomers = async (): Promise<
  KiedyNaboryCustomer[]
> => {
  const { data } = await apiClient.get<KiedyNaboryCustomer[]>(
    "/kiedynabory/settlements/customers"
  );
  return data;
};

/**
 * Get monthly settlement summary
 * @param month - Month in YYYY-MM format
 */
export const getMonthlySettlement = async (
  month: string
): Promise<MonthlySettlement> => {
  const { data } = await apiClient.get<MonthlySettlement>(
    `/kiedynabory/settlements?month=${month}`
  );
  return data;
};

/**
 * Create a new settlement operation (cost or payout)
 * Admin-only endpoint.
 */
export const createSettlementOperation = async (
  dto: CreateOperationDto
): Promise<SettlementOperation> => {
  const { data } = await apiClient.post<SettlementOperation>(
    "/kiedynabory/settlements/operations",
    dto
  );
  return data;
};
